import { useState } from "react"
import { doc, getFirestore, setDoc } from "firebase/firestore"; 
import "../RegistrationForm.css"
import app from "../firebase"
import { getStorage, uploadBytes, ref } from "firebase/storage";
import thirty from "../stock/30Rs.png"
import forty from "../stock/40Rs.png"
import QR from "../stock/WAQR.jpeg"
import QR2 from "../stock/WAQR2.jpeg"
export default function App() {
   
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [division,setDivision] = useState("Novice");
    const [varsrc,setVarsrc] = useState(forty);
    const db = getFirestore(app);
    const [data,setData] = useState({
      fullName: '',
      email: '',
      wpMobNo: '',
      prn: '',
      branch: '',
      yrr: '',
      ieeeMember: false,
      memberId: '',
      time: '',
      timestamp: {
        seconds: 0,
        nanoseconds: 0,
      }
    })
    const handleInputChange = (e) => {
      const { name, value, type, checked } = e.target;
    
      // Debugging: Check if the event is being triggered correctly
    
      if (type === "checkbox") {
        setData((prevFormData) => ({
          ...prevFormData,
          [name]: checked, // Update the checkbox value based on 'checked'
        }));
      } else {
        setData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    
      // Rest of your code...
      if (name === "yrr") {
        console.log("yrr",value);
        if ((value === "FY") || (value === "SY")) {
          setDivision("Novice");
        } else {
          setDivision("Expert");
        }
      } 
      if (name === "ieeeMember") {
        setVarsrc(data.ieeeMember ? forty  : thirty);
      }
    };
    

    const handleSubmit = async (e) => {
      e.preventDefault(); 
      const timestamp1 = {
        seconds: Math.floor(Date.now() / 1000),
        nanoseconds: 0,
      };
    
      console.log(timestamp1);
    
      await setDoc(doc(db, "treasureHunt", data.prn.trim()), {
        ...data, // Include existing data
        timestamp: timestamp1, // Include the new timestamp here
      });
    
      handleUpload(data.prn);
      setIsSubmitted(true);
    }
    
    

  const [imageFile, setImageFile] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const imageBlob = new Blob([reader.result], { type: file.type });
        const imageFile = new File([imageBlob], file.name, { type: file.type });

        setImageFile(imageFile);
        const imageElement = document.getElementById('preview');
        const imageUrl = URL.createObjectURL(imageFile);
        imageElement.src = imageUrl;
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleUpload=(prn)=>{
    const storage = getStorage();

    const storageRef = ref(storage, 'stock/'+prn + "TH");
    uploadBytes(storageRef, imageFile).then((snapshot) => {
        console.log('Uploaded a blob or file!',snapshot);
      });

}
  
    if(!isSubmitted) {
        return (
    <div className="container">
    <p style={{fontSize: "30px", textAlign: "center"}} className="form-label">Code Spark Registration</p>
    <form onSubmit={handleSubmit}>
        <div className="form-question">
            <label className="form-label" htmlFor="fullName">
            Full Name
            </label>
            <input
                className="form-input"
                type="text"
                name="fullName"
                value={data.fullName}
                onChange={handleInputChange}
                required={true}
                
            />
        </div>

      <div className="form-question">
        <label className="form-label" htmlFor="prn">
          PRN
        </label>
        <input
            type="text"
            name="prn"
            value={data.prn}
            onChange={handleInputChange}
            required={true}
            className="form-input"
        />
        
      </div>

      <div className="form-question">
        <label className="form-label" htmlFor="email">
          Email Address
        </label>
        <input
            type="text"
            name="email"
            value={data.email}
            onChange={handleInputChange}
            required={true}
            className="form-input"
        />
        
      </div>

      <div className="form-question">
        <label className="form-label" htmlFor="wpMobNo">
          WhatsApp Number
        </label>
        <input
            type="number"
            name="wpMobNo"
            value={data.wpMobNo}
            onChange={handleInputChange}
            required={true}
          className="form-input"
        />
        
      </div>

      <div className="form-question">
  <label className="form-label" htmlFor="branch">
    Department
  </label>
  <select
    name="branch"
    value={data.branch}
    onChange={handleInputChange}
    required={true}
    className="form-input"
  >
    <option value="">Select a department</option>
    <option value="AI ML">Computer Sc. & Engineering (AI and ML)</option>
    <option value="AI and DS">AI and Data Science</option>
    <option value="CSE">Computer Sc. & Engineering</option>
    <option value="CIVIL">Civil Engineering</option>
    <option value="ELECTIC">Electrical Engineering</option>
    <option value="ENTC">Electronics & Telecommunication Engineering</option>
    <option value="MECH">Mechanical Engineering</option>
  </select>
</div>


      <div className="form-question">
        <label className="form-label" htmlFor="yrr">
          Year
        </label>
        <select
          name="yrr"
          value={data.yrr}
          onChange={handleInputChange}
          required={true}
          className="form-input"
        >
          <option value="">Select a year</option>
          <option value="FY">First Year</option>
          <option value="SY">Second Year</option>
          <option value="TY">Third Year</option>
        </select>
      </div>


      <div className="form-question">
        <label className="form-label">
          Check this box if you have existing IEEE Membership?
          <input
            type="checkbox"
            name="ieeeMember"
            value={data.ieeeMember}
            onChange={handleInputChange}
            className="form-input-checkbox"
          />
        </label>
      </div>

      <div className="form-question">
        <label className="form-label" htmlFor="memberId">
          Member ID
        </label>
        <input
            type="text"
            name="memberId"
            value={data.memberId}
            onChange={handleInputChange}
            required={data.ieeeMember}
            className="form-input"
        />
      </div>
    

      <div className="form-question">
        <label className="form-label" >
          Scan this QR for payment
        </label>
        <div style={{display: "flex"}}>

        <img src={varsrc} style={{height: "400px",width: "auto",margin: "auto"}}></img>
        </div>
      </div>
      <div className="form-question">
        <label className="form-label" htmlFor="paymentSS">
          Upload Payment Screenshot
        </label>
        <input type="file" accept="image/*" onChange={handleImageChange} required={true}/>
      </div>

      <div className="form-question">
        {imageFile && <label className="form-label" >
        This is your <strong>Payment Preview</strong>
        </label>}
        <div style={{display: "flex"}}>
        <img id='preview' style={{maxHeight: "400px",width: "auto",margin: "auto"}}></img>

        </div>
      </div>
      
      <input className="form-submit" type="submit" />
    </form>
  </div>

  );
        }
  if(isSubmitted){ return (

    <div className="container">
        <div>
        <p>Thank you for filling the form! Your details have been submitted successfully.</p>
        {division==="Expert" && <p>Kindly Join the <a href='https://chat.whatsapp.com/GMU5qAadtvPLuGLMAIn7HF' style={{textDecorationColor: "green"}}><span style={{color: "green"}}>WhatsApp Group </span></a> for further Updates</p>}
        {division==="Novice" && <p>Kindly Join the <a href='https://chat.whatsapp.com/Jc7m6O0WLlHFWkEuSXetiw' style={{textDecorationColor: "green"}}><span style={{color: "green"}}>WhatsApp Group </span></a> for further Updates</p>}
        <div className="events-section" style={{display: "flex",justifyContent: "center",flexWrap: "wrap"}}>
            <div style={{ backgroundColor: 'white', borderRadius: '6px', width: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: "90%" }}>
               {division==="Expert" && <img src={QR2} style={{ margin: '20px auto', borderRadius: '6px', maxWidth: '95%' }} alt="Your Image" />}
               {division==="Novice" && <img src={QR} style={{ margin: '20px auto', borderRadius: '6px', maxWidth: '95%' }} alt="Your Image" />}
            </div>
        </div>
        </div>
    </div>
  )
  }
}